import { useMutation } from 'Data/Api.js'
import mutationUpdateScheduleNote from './mutation-update-schedule-note.graphql.js'
import mutationUpdateAppointmentDuration from './mutation-update-appointment-duration.graphql.js'
import mutationRescheduleAppointment from './mutation-reschedule-appointment.graphql.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { useDataSubmit } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onActionUpdateScheduleNote = useDataOnActionUpdateScheduleNote(
    props,
    data
  )
  let onActionUpdateAppointmentDuration =
    useDataOnActionUpdateAppointmentDuration(props, data)
  let onActionRescheduleAppointment = useDataOnActionRescheduleAppointment(
    props,
    data
  )

  return async function onSubmit({ args, ...otherProps }) {
    switch (args.type) {
      case 'updateScheduleNote': {
        return await onActionUpdateScheduleNote({ args, ...otherProps })
      }
      case 'updateAppointmentDuration': {
        return await onActionUpdateAppointmentDuration({ args, ...otherProps })
      }
      case 'rescheduleAppointment': {
        return await onActionRescheduleAppointment({ args, ...otherProps })
      }
      default: {
      }
    }
  }
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
function useDataOnActionUpdateScheduleNote(props, data) {
  let [, executeMutation] = useMutation(mutationUpdateScheduleNote)

  // @ts-ignore
  let [, notify] = useNotifications()
  return async function onAction({ args }) {
    let { id, duration, start_time, event_type, chair_id } = args

    if (typeof duration !== 'undefined' || typeof start_time !== 'undefined') {
      let mutationResponse = await executeMutation({
        id,
        data:
          typeof duration !== 'undefined'
            ? { duration, chair_id }
            : { start_time, chair_id },
      })

      if (mutationResponse.error) {
        notify(
          notifyError(
            typeof duration !== 'undefined'
              ? 'Could not update the duration. Please try again.'
              : 'Could not update the start time. Please try again.'
          )
        )
        args.revert?.()
        return false
      }

      notify(
        notifySuccess(
          event_type === 'note'
            ? 'Calendar note updated successfully'
            : 'Blocked time updated successfully'
        )
      )
    }

    return true
  }
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
function useDataOnActionUpdateAppointmentDuration(props, data) {
  let [, executeMutation] = useMutation(mutationUpdateAppointmentDuration)
  let [, notify] = useNotifications()

  return async function onAction({ args }) {
    let { id, duration } = args

    let mutationResponse = await executeMutation({
      id,
      duration,
    })

    if (mutationResponse.error) {
      notify(notifyError('Could not update appointment duration'))
      args.revert?.()
      return false
    }

    notify(notifySuccess('Appointment duration updated successfully'))
    return true
  }
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
function useDataOnActionRescheduleAppointment(props, data) {
  let [, executeMutation] = useMutation(mutationRescheduleAppointment)
  let [, notify] = useNotifications()

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return async function onAction({ value, args }) {
    let mutationResponse = await executeMutation({
      patient_id: args.patient_id,
      location_id: value.location.id,
      appointment_id: args.appointment_id,
      appointment_type_id: args.appointment_type_id,
      chair_id: args.chair_id,
      date: args.start_time.split('T')[0],
      start_time: args.start_time.split('T')[1],
      end_time: args.end_time.split('T')[1],
    })

    if (mutationResponse.error) {
      notify(notifyError('Could not reschedule appointment'))
      args.revert?.()
      return false
    }

    submit({ type: 'appointmentQueue/remove', id: args.id })
    notify(notifySuccess('Appointment rescheduled successfully'))
    return true
  }
}
